
import loadJsonFromText from './loadJsonFromText';

import Log from '../log';
let log = Log.getLogger('MultiSceneForApp.utils.loadJsonFromUrl');

export default function loadJsonFromUrl(url, callback) {
    let options = {
        method: 'GET',
        mode: 'cors'
    };

    fetch(new Request(url, options))
        .then(response => {
            return response.text();
        })
        .then(content => {
            loadJsonFromText(content, callback);
        })
        .catch(error => {
            log.error('fetch JSON failed:', error);
            callback(error);
        });
}
